import { createAsyncThunk } from '@reduxjs/toolkit';
import { specificationService } from '@/shared/services/api/specification-service';
import { ISpecificationListGetRequest } from '@/shared/services/interface/requests/specification';

export const getSpecificationListThunk = createAsyncThunk(
  "specificationList/getSpecificationList",
  async (
    {
      userId,
      companyId,
      offset,
      limit,
      sortBy,
      search,
      status
    }: ISpecificationListGetRequest,
    { rejectWithValue }
  ) => {
    try {
      const response = await specificationService.getSpecificationList({
        userId,
        companyId,
        offset,
        limit,
        sortBy,
        search,
        status
      });
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Bir hata oluştu");
    }
  }
);
